
import { Base } from '../base-component';
import './footer.component.scss';
import './about-card/about-card.component.scss';
import './app-card/app-card.component.scss';
import './contact-card/contact-card.component.scss';
import './footer-card/footer-card.component.scss';
export class FooterContainer extends Base {

	constructor(element: Element){
		super(element);
	}

	init(){ }

	bindEvents() {}


}


// WEBPACK FOOTER //
// ./components/footer/footer.component.ts